import React from 'react'
import EditText, { EditTextPassword } from 'blocks.simple/editText/editText'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './styles'
import { text as textStyles } from 'theme'
import grid from 'blocks.simple/grid/grid.jcss'
import { Typography } from 'atoms/Typography'

const QbicAuthorizationSettings = (p_: { onChange: (data: any) => void; settings: any }) => {
    const onChangeField = (field: string, value: string) => {
        p_.onChange({ field, value })
    }

    return (
        <div className={grid.mb_mdPlus}>
            <Typography className={cn(textStyles.normal, styles.caption)} type="title">
                {translate('login')}
            </Typography>
            <div className={styles.fieldsWrapper}>
                <EditText
                    mod={'withBorder'}
                    label={translate('adLogin')}
                    value={p_.settings.qbicLogin || ''}
                    onChange={function (login: any) {
                        onChangeField('qbicLogin', login)
                    }}
                    containerClass={styles.inputWrapper}
                />
                <EditTextPassword
                    mod={'withBorder'}
                    label={translate('password')}
                    value={p_.settings.qbicPassword || ''}
                    onChange={function (password: string) {
                        onChangeField('qbicPassword', password)
                    }}
                    containerClass={styles.inputWrapper}
                    autocompletePasswordOff={true}
                />
            </div>
        </div>
    )
}

export default QbicAuthorizationSettings
